import React, { Component } from 'react';
import { Form, Table, Button, Checkbox } from 'react-bootstrap';
import Api from '../../../../Global/Modules/Api'

class BijeenkomstNew extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSortingClick = this.handleSortingClick.bind(this);
        this.handlePaginationClick = this.handlePaginationClick.bind(this);
        this.state = {
            CourseDate: "sorting",
            Institution: "sorting",
            Name: "sorting",
            educations: [],
            errors: {},
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 10,
                totalCount: 0,
                orderBy: ""
            },
            currentFetchUrl: ''
        }
    }

    componentWillReceiveProps(props) {
        this.setState({ currentFetchUrl: 'api/educations/' + props.year + '/' + props.course + '/meetings' })
        const FETCH_URL = 'api/educations/' + props.year + '/' + props.course + '/meetings';
        this.getNews(FETCH_URL)
    }
    handlePaginationClick(e) {
        const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL2 })
        this.getNews(FETCH_URL2)
    }
    handleSortingClick(e) {
        var columnName = e;
        var newSort = this.state.pagination.orderBy.indexOf(e) >= 0 ? this.state.pagination.orderBy.indexOf("asc") >= 0 ? this.state.pagination.orderBy.replace("asc", "desc") : this.state.pagination.orderBy.replace("desc", "asc") : e + " asc";
        this.setState({ CourseDate: "sorting" })
        this.setState({ Institution: "sorting" })
        this.setState({ Nane: "sorting" })
        this.setState({ [columnName]: newSort.indexOf("asc") >= 0 ? "sorting_asc" : "sorting_desc" })
        this.setState({ pagination: { ...this.state.pagination, orderBy: newSort } })
        this.getNews(this.state.currentFetchUrl + "?OrderBy=" + newSort)
    }
    getNews(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined) {
                let news = objectData.educations.map(function (item, index) {
                    return <tr key={item.id}>
                        <td>{Api.formatDate(item.courseDate)}</td>
                        <td>{item.institution}</td>
                        <td>{item.name}</td>
                        <td>{item.points}</td>
                        <td><Checkbox name="MeetingBox" value={item.id} defaultChecked={item.phone == "1" ? "checked" : ""} /></td>
                    </tr>
                })
                this.setState({ educations: news });
            }
        });
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var payload = {}
        const formData = event.target.elements
        var checkeds = '';
        var uncheckeds = '';

        for (var i = 0; i < formData.length; i++) {

            const e = formData[i]
            const value = e.value
            const name = e.name
            if (name == "MeetingBox") {
                if (e.checked) {
                    checkeds = checkeds == '' ? e.value : checkeds + ',' + e.value;
                } else {
                    uncheckeds = uncheckeds == '' ? e.value : uncheckeds + ',' + e.value;
                }
            }
        }

        payload['checkedMeetings'] = checkeds;
        payload['uncheckedMeetings'] = uncheckeds;
        Api.PostApi('api/educations/updatemeetings', payload, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    this.setState({ errors: response });
                } else {
                    alert("Bijeenkomst updated")
                    window.location.href = '/kennis/beheren'
                    //window.location.href = '/admin/leden/lid/kennis/' + this.props.id
                }

            })

    }


    render() {
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <div>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <Table responsive striped bordered hover className="dataTable BijeenkomstResultTable text-center">
                        <thead>
                            <tr>
                                <th className={this.state.CourseDate} onClick={() => this.handleSortingClick("CourseDate")} >Datum</th>
                                <th className={this.state.Institution} onClick={() => this.handleSortingClick("Institution")} >Organisator</th>
                                <th className={this.state.Name} onClick={() => this.handleSortingClick("Name")} >Naam bijeenkomst</th>
                                <th>PE punten</th>
                                <th>Aanwezigheid</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.educations}
                        </tbody>
                    </Table>
                    <div className="text-left">
                        {this.state.pagination.prevButton}
                    </div>
                    <div className="text-center">
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div className="text-right">
                        {this.state.pagination.nextButton}
                    </div>
                    <br />
                    <div className="text-right">
                        <Button type='submit'>Opslaan</Button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default BijeenkomstNew;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/BijeenkomstNew.js